import { render, staticRenderFns } from "./EModalCarteira.vue?vue&type=template&id=623aa305"
import script from "./EModalCarteira.vue?vue&type=script&lang=js"
export * from "./EModalCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports